import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BankAccountSelect } from "../../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { _BankingConciliationReport, _ConciliationReport } from "../../../../../core/services/dataBean/EntityCatalogVdos";



export const BankingConciliationReport = () => {

    const BankingConciliationReport = useDataBean(_BankingConciliationReport);
    const ConciliationReport = useDataBean(_ConciliationReport);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [docs, setDocs] = useState<{ url: string, name: string } | null>(null);
    const [modalreporte, setModalreporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [listavdos, setListavdos] = useState<any>([]);
    const [BankingAccount, setBankingAccount] = useState<number>(null)
    const [year, setyear] = useState<number>(null)
    const [month, setmonth] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        if (modalreporte.view) {
            getBankingConciliationReport();
        }
    }, [modalreporte.view]);

    const getLista = () => {

        BankingConciliationReport.instance.getBankingConciliation(BankingAccount, year, month).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }


    const getBankingConciliationReport = () => {
        ConciliationReport.instance.getBankingConciliationReport(BankingConciliationReport.bean.IDBankingConciliation)
            .then((resp: any) => {
                if (resp && resp.length > 0) {
                    toast.success('Reporte');


                    const fileData = resp[0]?.DataBeanProperties;
                    if (fileData) {
                        setDocs({
                            url: fileData.URLLink,
                            name: fileData.Filename
                        });
                    }
                }
            })
            .catch(() => toast.error("No se pudo obtener el reporte"));
    };

    const create = () => {
        BankingConciliationReport.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        BankingConciliationReport.deleteItemVoid(BankingConciliationReport.bean.IDBankingConciliation).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        BankingConciliationReport.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID Conciliación', property: 'IDBankingConciliation', visible: true },
        { title: 'Fecha Inicial', property: 'StartingDate', visible: true },
        { title: 'Fecha Final', property: 'EndingDate', visible: true },
        { title: 'Saldo en Banco', property: 'BankingLeft', visible: true },
        { title: 'Saldo en Auxiliar', property: 'AuxiliaryLeft', visible: true },
    ]
    const headtwo = [
        { title: 'ID', property: 'IDReport', visible: true },
        { title: 'Tipo Reporte', property: 'IDReportType', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Requiere Fecha desde', property: 'RequiresFromDate', visible: true },
        { title: 'Requiere Fecha hasta', property: 'RequiresUptoDate', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Reporte', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalreporte({ ...modalreporte, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar Conciliaciones Bancarias">
            <div className="row">
                <div className="col-md-4">
                    <BankAccountSelect label="Cuenta Bancaria" idSelector={BankingAccount} onChange={(e) => { setBankingAccount(e) }} />
                </div>
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Conciliar Banco
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={BankingConciliationReport.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modalreporte} updateModal={setModalreporte} >
                        <>
                            {/* <PrintJson json={docs} /> */}
                            <div className="row">
                                {docs && (
                                    <div className="row mt-3">
                                        <div className="col-md-12 text-center">
                                            <a
                                                href={docs.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-link"
                                            >
                                                📄  {docs.name || "Abrir archivo"}
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {BankingConciliationReport.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}